import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const CTAHrisSection = () => {
  const ctaRef = useRef();
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.3 }
    );

    if (ctaRef.current) observer.observe(ctaRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="cta-hris-section py-5">
      <div
        ref={ctaRef}
        className={`cta-hris-card text-center rounded-4 p-5 ${
          isVisible ? "slide-in-left" : ""
        }`}
      >
        <h2 className="CTA-TITLE fw-bold mb-4">
          Ready to Streamline Your HR Processes?
        </h2>
        <p className="mb-4 fs-5 text-dark">
          Partner with numerous organizations that have already optimized their
          human resource management through our comprehensive digital platform.
          Schedule a demonstration today to explore how we can help streamline
          your HR operations.
        </p>
        <div className="d-flex justify-content-center gap-3 flex-wrap">
          <button
            type="button"
            className="btn"
            style={{
              backgroundColor: "#020248",
              color: "white",
              borderRadius: "8px",
              padding: "8px 16px",
              fontSize: "15px",
              border: "0 solid transparent",
            }}
            onClick={() => {
              const modal = new window.bootstrap.Modal(
                document.getElementById("demoRequestModal")
              );
              modal.show();
            }}
          >
            Request Demo
          </button>

         <button
  className="btn-btn-demo px-4 py-2 fw-semibold"
  onClick={() => window.location.href = "/contact"}
>
  Contact Us
</button>
        </div>
      </div>
    </section>
  );
};

export default CTAHrisSection;
